// extracted by mini-css-extract-plugin
module.exports = {"root":"Copyable_root__RTKRV","text":"Copyable_text__OPqgb","cta":"Copyable_cta__rR5Ls","labelText":"Copyable_labelText__lgfMo"};